

































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardInputSKMata from "@/components/pemeriksaan/resumeSuketV2/CardInputSKMata.vue";
import moment from "moment";
import SuketMata from "@/services/SuketMata";
import StoreSuketMata from "@/store/modules/SuketMata";
import { SuketMataInterface } from "@/types/suket_mata";
import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";
import BaseCardSuket from "./BaseCardSuket.vue";
import { userModule } from "@/store/modules/user";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";

@Component({
  components: {
    CardModalTtd,
    CardInputSKMata,
    ConfirmDialog,
    BaseCardSuket
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class CardSKMata extends Vue {
  @Prop() readonly register!: string;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  allowedUnit = ["04", "2K", "2Q"];
  modalTtd = false;
  isBussy = false;

  get examCategory() {
    return StoreSuketMata.examInputCategory;
  }

  get dataSKMata(): SuketMataInterface {
    return StoreSuketMata.suket;
  }

  get tglSurat() {
    return moment(this.dataSKMata?.exam_date).format("DD-MM-YYYY");
  }

  get loadContent() {
    return StoreSuketMata.loading;
  }

  get creatorUserId() {
    return this.dataSKMata?.dr_id;
  }

  get signeeUserId() {
    return this.dataSKMata?.dr_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return !this.allowedUnit.includes(userModule.user.unit_id);
    // return false;
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketMata.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    SuketMata.sign(this.dataSKMata.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan SKDP");
          appModule.addMsgTtd("");
          StoreSuketMata.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  remove() {
    this.isBussy = true;
    SuketMata.destroy(this.dataSKMata?.id)
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Hapus Surat Keterangan Mata");
          StoreSuketMata.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        this.isBussy = false;
      });
  }
}
